module.exports = __webpack_public_path__ + "img/icon-follow-pop.31deea24.png";